import { applyLocalStorageMock } from "@tiny/utils";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { getSentryConfig, isSentryEnabled } from "@tiny/utils/envVars";
import { initializeSentry } from "@tiny/sentry";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import NotificationSnackbarProvider from "./components/Snackbar/snackbar-provider";
import App from "./App";

applyLocalStorageMock();

if (isSentryEnabled()) {
  const config = getSentryConfig();
  initializeSentry({
    ...config,
    instrumentationFns: [
      React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    ],
  });
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  // NOTE: React.StrictMode removed because @tiny/components uses @mui/styles
  // (legacy JSS), which is incompatible with React 18 StrictMode — StrictMode's
  // dev-only double mount detaches dynamic (function-rule) JSS sheets and never
  // re-attaches them, so components like IconPanel/EmptyState render unstyled.
  <NotificationSnackbarProvider>
    <App />
  </NotificationSnackbarProvider>
);
